import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const hasWork = !(injured.work && ['0', ''].includes(injured.work.hasWork))

	let workInfoList = []
	if (injured.work && injured.work.workInfoList.length) {
		workInfoList = injured.work.workInfoList
	}

	const modal = [
		{
			label: '所属行业',
			value: '',
			key: 'industry',
			type: 'select',
			selectOption: setting.paicIndustryList,
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '职业类别（一级）',
			value: '',
			key: 'vocation',
			type: 'select',
			selectOption: [],
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '职业类别（二级）',
			value: '',
			key: 'secondVocation',
			type: 'select',
			selectOption: [],
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '工作单位',
			value: '',
			key: 'companyName',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 20,
					message: '长度不能超过20位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工作地区',
			value: '',
			key: 'workAddress',
			type: 'searchSelect',
			selectOption: [],
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '详细地址',
			value: '',
			key: 'workPlace',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 50,
					message: '长度不能超过50位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工作起止日期',
			value: [],
			key: 'dateArr',
			type: 'daterange',
			notNull: '1',
			canEdit: true,
			allowClear: false,
			formSpan: 8,
		},
		{
			label: '岗位名称',
			value: '',
			key: 'jobName',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 10,
					message: '长度不能超过10位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工资发放形式',
			value: '',
			selectOption: setting.wageTypeList,
			key: 'wageType',
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '自述工资/收入',
			value: '',
			key: 'wage',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			symbol: '元/月',
			rules: [
				{
					pattern: /(^[0-9]{1,6}$)|(^[0-9]{1,6}[\\.]{1}[0-9]{1,2}$)/,
					message: '请输入7位数内正确金额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '是否签订劳动合同',
			value: '',
			selectOption: setting.yesNoList,
			key: 'contract',
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
			labelSpan: 13,
		},
		{
			label: '备注（非必填）',
			value: '',
			key: 'remark',
			type: 'text',
			notNull: '0',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 100,
					message: '长度不能超过100位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工作起始日期',
			value: '',
			key: 'beginDate',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
		},
		{
			label: '工作截止日期',
			value: '',
			key: 'endDate',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
		},
	]

	const list = workInfoList.map((item, index) => {
		let beginDate = item.beginDate
			? moment(formatDate(item.beginDate), 'YYYY-MM-DD')
			: ''
		let endDate = item.endDate
			? moment(formatDate(item.endDate), 'YYYY-MM-DD')
			: ''
		const valArr = [
			item.industry,
			item.vocation,
			item.secondVocation,
			item.companyName,
			item.workAddress,
			item.workPlace,
			beginDate && endDate ? [beginDate, endDate] : [],
			item.jobName,
			item.wageType,
			item.wage,
			item.contract,
			item.remark,
			beginDate,
			endDate,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			let obj = {
				...moadlItem,
				value: valArr[valIndex],
			}
			// 组装职业大类列表数据
			if (obj.key == 'vocation') {
				obj.selectOption = [
					{
						key: item.vocation,
						value: item.vocationName,
					},
				]
			}
			// 组装职业小类列表数据
			if (obj.key == 'secondVocation') {
				obj.selectOption = [
					{
						key: item.secondVocation,
						value: item.secondVocationName,
					},
				]
			}
			// 组装工作地区列表数据
			if (obj.key == 'workAddress') {
				obj.value =
					item.provinceCode + '-' + item.cityCode + '-' + item.areaCode
				obj.selectOption = [
					{
						key: item.provinceCode + '-' + item.cityCode + '-' + item.areaCode,
						value: item.workAddress,
					},
				]
			}

			return obj
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '伤者至少超过一年的完整工作经历',
		key: 'work.workInfoList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		work: {
			hasWork: hasWork,
		},
	}

	return obj
}
